import { i18n } from '@/locales';
const lc = 'views.hub_management.';
// 허브상태 타입(hubStatusType)
// 목록 : 전체/정상/정지/종료/사용요청
// https://dev-zoo-client-api.barogo.io/docs/common/hub-status.html
export const shareInfoStatusTypeCode = [
    'ALL',
    'ON', // 정상
    'PAUSE', // 정지
    'OFF', // 종료
    'REQUEST', // 사용요청
    'DELETE', // 삭제
];
const imgIconCodeList = {
    ALL: '',
    ON: 'ok',
    PAUSE: 'stop',
    OFF: 'leave',
    REQUEST: 'register-request',
    DELETE: '', // 삭제
};
export default shareInfoStatusTypeCode.map((code, index) => ({
    text: i18n.t(`${lc}status_code_type_list[${index}]`),
    value: code,
    field: 'hubStatus',
    imgIcon: imgIconCodeList[code],
}));
